import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function getOrderDetailsV2(request) {
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  const apiPath = `v1/details?wmsOrderId=${request.wmsOrderId}&status=${request.orderStatus}`
  return httpClient.shippingInstance().get(apiPath)
}
